module.exports = __webpack_public_path__ + "static/media/alexis1.a4c73f54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/alexis1.jpg
// module id = 90
// module chunks = 0